import { BodyWeight } from "components/BodyWeight";
import React from 'react';

export const WeightOverview = () => {
    return <BodyWeight />;
};